import React from "react";
import { Input, Space } from "antd";
import { CountrySelect } from "@ifa/ui";

export interface PhoneInputValue {
  /**
   * 完整电话号码（格式：区号 + 空格 + 号码，如 "852 12345678"）
   */
  phone?: string;
}

interface PhoneInputProps {
  /**
   * 电话号码值
   */
  value?: string;
  /**
   * 电话号码变化回调
   */
  onChange?: (phone: string) => void;
  /**
   * 是否只读
   */
  readOnly?: boolean;
  /**
   * 占位符文本
   */
  placeholder?: string;
}

/**
 * 手提电话输入组件
 * 专用于输入国际电话号码（区号 + 号码）
 */
export const PhoneInput: React.FC<PhoneInputProps> = ({ value = "", onChange, readOnly = false, placeholder = "請輸入" }) => {
  // 拆分区号和电话号码
  const phoneParts = (value || "").split(" ");
  const areaCode = phoneParts.length > 1 ? phoneParts[0] : "852";
  const phoneNumber = phoneParts.length > 1 ? phoneParts.slice(1).join(" ") : value || "";

  const handleAreaCodeChange = (code: string) => {
    const newPhone = `${code} ${phoneNumber}`;
    onChange?.(newPhone);
  };

  const handlePhoneNumberChange = (num: string) => {
    // 只允许数字
    const sanitized = num.replace(/\D/g, "");
    const newPhone = `${areaCode} ${sanitized}`;
    onChange?.(newPhone);
  };

  return (
    <Space.Compact style={{ width: "100%" }}>
      <CountrySelect
        type="phone"
        style={{
          width: 140,
          borderRadius: "6px 0 0 6px",
        }}
        value={areaCode}
        onChange={(v) => handleAreaCodeChange(v)}
        readOnly={readOnly}
      />
      <Input
        type="number"
        placeholder={placeholder}
        value={phoneNumber}
        inputMode="decimal"
        style={{
          borderRadius: "0 6px 6px 0",
          borderLeft: "none",
        }}
        onChange={(e) => handlePhoneNumberChange(e.target.value)}
        disabled={readOnly}
      />
    </Space.Compact>
  );
};
